module.exports = __webpack_public_path__ + "img/bulksend.02cbea28.svg";